module.exports = {"helmetTitle":"Veloe - Endereço Comercial","title":"Endereço comercial","subtitle":"Mantenha o endereço da sua empresa sempre atualizado para não ter problemas de correspondência.","secondaryAddressTitle":"Endereço secundário","excludeLink":"Excluir","lastSaved":"Salvo em 10/10/2017 às 19:30","modalUpdateTitle":"Pronto! A gente já salvou suas alterações. ;)","modalDeleteTitle":"Pronto! Agora, sua correspondência vai para o endereço principal."}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/EditCompanyAddress/data.json
// module id = 1741
// module chunks = 0